import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {RouterOutlet} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LightboxModule} from '@pierresh/ngx-lightbox';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BreadcrumbComponent, BreadcrumbItemDirective, BreadcrumbService} from "xng-breadcrumb";
import {HeaderComponent} from "./header/header.component";
import {FooterComponent} from "./footer/footer.component";
import {FullLayoutComponent} from "./layout/full-layout-component";
import {Globals} from "./globals";
import {AllSidebarComponent} from "./all-sidebar/all-sidebar.component";
import {AllChildComponent} from "./all/all-child.component";
import {NgxPaginationModule} from "ngx-pagination";
import {AllViewItemComponent} from "./all/all-view-item.component";
import {CommonModule} from "@angular/common";
import {MaterialModule} from "./material/material.module";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {FlexLayoutModule} from "@ngbracket/ngx-layout";
import {SidenavListComponent} from "./sidenav-list/sidenav-list.component";
import {SidenavItemComponent} from "./sidenav-all-item/sidenav-all-item.component";
import {AlertModule} from "./_alert";
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {ListingBrowsePagesModule} from "./category/listing-browse/listing-browse-pages.module";
import {BrowseSharedModule} from "./shared/browse-shared.module";
import {LoginComponent} from "./login/login.component";
import {SignupComponent} from "./signup/signup.component";
import {ProfileComponent} from "./profile/profile.component";
import {PaymentComponent} from "./payment/payment.component";
import {CheckoutComponent} from "./checkout/checkout.component";
import {OrdersComponent} from "./orders/orders.component";
import {DropshipComponent} from "./dropship/dropship.component";
import {AppRoutingModule} from "./appp-routing.module";
import {MessagingComponent} from "./messaging/messaging.component";
import {AddItemComponent} from "./add-item/add-item.component";
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  GoogleLoginProvider
} from '@abacritt/angularx-social-login';
import {ListingBrowseUiModule} from "./shared/listing-browse-ui/listing-browse-ui.module";
import {authInterceptorProviders} from "./_helpers/auth.interceptor";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    AddItemComponent,
    HeaderComponent,
    SidenavListComponent,
    FooterComponent,
    FullLayoutComponent,
    // ItemComponent,
    AllSidebarComponent,
    AllChildComponent,
    AllViewItemComponent,
    SidenavItemComponent,
    ProfileComponent,
    LoginComponent,
    SignupComponent,
    PaymentComponent,
    CheckoutComponent,
    OrdersComponent,
    DropshipComponent,
    MessagingComponent,
  ],
  imports: [
    AppRoutingModule,
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    LightboxModule,
    MaterialModule,
    DragDropModule,
    NgxPaginationModule,
    NgxSliderModule,
    RouterOutlet,
    AlertModule,
    SocialLoginModule,
    ListingBrowseUiModule,
    BrowseSharedModule,
    ListingBrowsePagesModule,
  ],
  exports:[],
  providers: [
    BreadcrumbService, Globals,
    ...authInterceptorProviders,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '681071664856-e15pa1gbvof8t1acc4mkq9909lc0b89u.apps.googleusercontent.com'
            )
          }
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

